<template>
  <survey-calculator background-color="#FFFFFF" template-id="OpinionSurvey" />
</template>
<script>
import SurveyCalculator from "./SurveyCalculator";
export default {
  name: "OpinionSurveyCalculator",
  components: { SurveyCalculator },
};
</script>
